import React, {Component} from 'react';
import {Button, Form, Segment, Grid, Image, Confirm, Header} from 'semantic-ui-react';
import Loader from "../universal/loader";
import {getCustomReportDetails, uploadCustomReport} from "../../data/custom_report_upload_api";
import * as fileIcon from "../../assets/fileIcon.png";
import {changeInspectionStatus} from "../../data/inspection_api";
import {INSPECTION_API_URL} from "../../constants/api_routes";
import AdditionalPhotos from './additional_photos';

class CustomReportUpload extends Component {

    constructor(props){
        super(props);
        this.state = {
            showUpload:false,
            customReportDetails:undefined,
            showConfirm:false,
            submitStatus:undefined,
        }
    }

    componentWillMount(){
        this.getReportDetails();
    }

    getReportDetails = () => {
        this.setState({showUpload:false});
        getCustomReportDetails(this.props.match.params.customReportId).then((response)=>{
            if(response['custom_report']){
                this.setState({showUpload:true,customReportDetails:response['custom_report']});
            }
            else {
                if(response.status === 401){
                    this.props.history.push('/signout');
                }
            }
        })
    };

    submitReport = () => {
        if(this.state.submitStatus){
            const formData = {
                inspection_id: this.state.customReportDetails['inspection']['id'],
                status: this.state.submitStatus
            };
            changeInspectionStatus(INSPECTION_API_URL, formData).then((response) => {
                if (response.success) {
                    this.props.history.push('/inspection');
                }
            })
        }
    };

    handleCancel = () => {
        this.setState({showConfirm:false,submitStatus:undefined})
    };

    handleSubmit = (e) => {
        this.setState({uploading:true});
        e.preventDefault();
        const formData = new FormData(e.target);
        uploadCustomReport(formData).then((response)=>{
            if(response.success){
                this.getReportDetails();
                this.setState({reportUploaded:true,uploading:false});
                setTimeout(()=>this.setState({reportUploaded:false}),5000);
            }
            else {
                this.setState({uploading:false});
            }
        });
    };

    render(){
        const customReportDetail = this.state.customReportDetails;
        let showAddReport = true;
        if(customReportDetail){
            if(customReportDetail['inspection']['inspection_status'] >= 5 || (customReportDetail['inspection']['inspection_status'] >= 4 && this.props.userRole === 'clerk')){
                showAddReport = false;
            }
        }

        return (<div className="short-listing-container" style={{width:'50%'}}>
            {this.state.uploading && <Loader save={true}/>}
            {this.state.showConfirm && <div><Confirm open={true} header="Confirm report submission" content="Report once submitted cannot be edited again" onCancel={this.handleCancel} onConfirm={this.submitReport} /></div>}
            {this.state.customReportDetails && this.state.customReportDetails['inspection'] &&
            <div className="pad-all header-sticky">
                {this.props.userRole === "clerk" &&
                <Button positive className="pull-right" content="Submit Report" onClick={() => {this.setState({showConfirm:true,submitStatus:"submitted"})
                }} />}
                {this.props.userRole === "admin" &&
                <Button positive className="pull-right" content="Complete Report" onClick={() => {
                    this.setState({showConfirm:true,submitStatus:"completed"})
                }} />}
                <Header as='h3'
                        content={this.state.customReportDetails['inspection']['inspection_reference_id'] ? "Reference ID : " + this.state.customReportDetails['inspection']['inspection_reference_id'] : ""}
                        textAlign='left'/>
                <Header as='h3'
                        content={this.state.customReportDetails['inspection']['address'] ? "Address : " + this.state.customReportDetails['inspection']['address'].replace(/,+/g, ",") : ""}
                        textAlign='left'
                        style={{marginTop: '0'}}
                />
            </div>}
            {this.state.reportUploaded && <div style={{width:'100%'}}>
                <p className="info-success right-aligned format-bold">Saved!</p>
            </div>}
            {this.state.showUpload ?
                <React.Fragment><Segment style={this.state.reportUploaded?{border:'2px solid green'}:{}}>
                    <Form onSubmit={this.handleSubmit}>
                        <input type="hidden" name="custom_report_id" value={this.props.match.params.customReportId} />
                        <Grid>
                            <Grid.Row>
                                {showAddReport && <Grid.Column width={8}>
                                    <Form.Field required>
                                        <label>Completed Custom Report File</label>
                                        <input type="file" name="file"  accept="application/pdf, application/doc, application/docx" required/>
                                    </Form.Field>
                                    <div className="right-aligned">
                                        <Button content={this.state.customReportDetails.file?"Re-Upload Report":"Upload Report"} primary icon="upload" labelPosition="right"/>
                                    </div>
                                </Grid.Column>}
                                <Grid.Column width={8}>
                                    {this.state.customReportDetails.file && <div className="center-aligned">
                                        <p className="format-bold">Previously Uploaded Report File</p>
                                        <Image as='a' target='_blank'
                                               href={this.state.customReportDetails.file}
                                               src={fileIcon}
                                               height="50px"
                                        />
                                    </div>}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                </Segment>
                <Segment><Header textAlign="left"> Photo Link  <span className="info-success">{this.state.customReportDetails.inspection.online_viewer_link}</span></Header></Segment>
                <Segment><AdditionalPhotos inspection_id={this.state.customReportDetails['inspection']['id']}/></Segment>
                </React.Fragment>:<div className="pad-top"> <Loader/></div>}
        </div>);
    }
}

export default CustomReportUpload;


// WEBPACK FOOTER //
// ./src/views/report/custom_report_upload.js